import axios from 'axios'
import {BUSCAR_MOTORISTAS} from '../types'
import {SLOW_REQUEST_CONFIG} from '../../util/loadingUtil'
import {URL} from '../../util/ambienteActions';

export default function buscarUsuariosMotorista(codigoEmpresa) {

    const url = `${URL}/usuarios/empresa/${codigoEmpresa}/motoristas`;
    return dispatch => axios.get(url, SLOW_REQUEST_CONFIG).then(
        response => dispatch({
            type: BUSCAR_MOTORISTAS,
            payload: response

        })
    );
}
